import React, {useEffect, useState} from 'react';
import {Ticket} from "types/Ticket";
import ConfirmModal from "components/ConfirmModal";
import {invalidate} from "services/query-client";
import {useMutation} from "react-query";
import ngage from "services/ngage";

type Props = {
    ticket: Ticket | null
    show: boolean
    onDelete?: (ticket: Ticket) => any
    onDeleteFail?: (ticket: Ticket, error: unknown) => any
    onCancel?: () => any
}

function DeleteTicket(props: Props) {
    const {ticket, show, onDelete, onDeleteFail, onCancel} = props

    const [name, setName] = useState<string>(ticket?.number || 'this ticket');
    const {mutateAsync: deleteTicket} = useMutation(ngage.tickets.destroy)

    useEffect(() => {
        if(ticket) setName(ticket.number)
    }, [ticket]);

    async function handleDeleteTicket() {
        if (ticket) {
            try {
                await deleteTicket(ticket.id)
                await invalidate('tickets.all')

                if (onDelete) onDelete(ticket)
            } catch (error) {
                if (onDeleteFail) onDeleteFail(ticket, error)
            }
        }
    }

    function handleCancel() {
        if (onCancel) onCancel()
    }

    return (
        <ConfirmModal
            show={show}
            type={ConfirmModal.types.DANGER}
            title="Delete Ticket "
            body={`Are you sure you want to permanently delete ticket '${name}'? This action cannot be undone.`}
            approveLabel="Delete"
            onApprove={handleDeleteTicket}
            onCancel={handleCancel}
        />
    );
}

export default DeleteTicket;